export default __webpack_public_path__ + "static/media/etapa2.b5e40d2a.png";